const getInitialsFromName = (name: string): string => {
  const nameParts = name.split(' ');
  if (nameParts.length == 1) return nameParts[0][0].toUpperCase();
  return nameParts[0][0]?.toUpperCase() + '' + nameParts[nameParts.length - 1][0]?.toUpperCase();
};

export default getInitialsFromName;
